<template>
    <v-container fluid ma-0 pa-0>
        <v-img max-height="600" :src="challenge.imgBase64">
            <!--<v-layout align-end justify-end fill-height>
                <v-flex class="text-xs-right">
                    <v-btn color="pink" dark large @click="navigate">Register here</v-btn>
                </v-flex>
            </v-layout>-->


        </v-img>
        <v-container grid-list-sm text-xs-left>


            <v-layout row wrap pa-2>
                <v-flex xs12 pa-3>
                    <span style="text-align: justify" :class="isMobile() ? 'display-1' :'display-3'"><strong>{{challenge.Title}}</strong></span>
                </v-flex>
                <v-flex xs12 pa-3>
                    <span class="headline"><strong>Challenge expiration date: </strong> {{challenge.date}}</span>
                </v-flex>
                <v-flex xs12 pa-3>
                    <span class="headline"><strong>Reward: </strong> {{challenge.reward}}</span>
                </v-flex>
                <v-flex xs12 pa-3>
                    <span class="headline"><strong>Description</strong></span>
                    <span style="text-align: justify" class="headline challengeDescription" v-html="challenge.Description"></span>
                </v-flex>
                <v-flex xs12 pa-3>
                    <div class="center-element">
                        <span class="headline"><strong>Tags: </strong></span>
                        <v-chip dark color="primary" v-for="tag in challenge.tags">{{tag}}</v-chip>
                    </div>


                </v-flex>

                <v-flex class="text-xs-center" pt-5>
                    <v-btn color="pink" dark large @click="navigate">Register here</v-btn>
                </v-flex>

            </v-layout>

        </v-container>
    </v-container>

</template>

<script>
    import RouterService from "@/helpers/RouterService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import FileInput from "@/components/Inputs/FileInput";
    import FileInputChallenge from "@/components/Inputs/FileInputChallenge";
    import DescriptionCreator from "@/pages/Admin/Innovation/ChallengeManagement/DescriptionCreator";
    import {mapGetters, mapState} from "vuex";

    export default {
        name: "PublicChallengeDetails",
        components: {DescriptionCreator, FileInputChallenge,},
        props: {
            _id: String,
        },
        computed: {
            ...mapState({}),
            ...mapGetters("UserState", {
                user: "getUserInfo",
            }),
        },
        data() {
            return {
                // default values for challenge - if the user doesn't insert a value, there will be no problem
                // if the object challenge change, change this default object too
                // the name of the variable has to be equal to name in MongoDB
                // remember to map this object in the searchStartupByChallenge function too
                challenge: {
                    Title: "",
                    Description: "",
                    imgBase64: "",
                    tags: [],
                    date: new Date().toISOString().substr(0, 10),
                    reward: "",
                    published: false,
                    createdBy: ""
                },

            }
        },
        created() {
            this.getChallenge();
        },
        methods: {
            navigate() {
                let path = {
                    name: "ChallengeRegistration",
                    params: {
                        _id: this._id,
                    },
                };
                RouterService.goTo(path);
            },
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
            getChallenge(){
                let requestUrl = {
                    url: UrlsService.getChallengePublic,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    id: this._id,
                    soloImg: false
                };
                let requestObject = {
                    type: "public",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Challenge",
                    loading: "Waiting for challenge...",
                    error: "Cannot get challenge...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let responseChallenge = responseSuccess;
                        this.challenge = responseChallenge
                    });
            }
        }

    }
</script>

<style scoped>

    .center-element {
        display: block;
        align-items: center;
    }
    .challengeDescription {
      word-break: break-word;
    }

</style>
